<div class="row mb-3">
	<div class="questionText col-10 col-md-6">{{Question.display_index}}. {{Question.prompt}}</div>
</div>
<div class="row checklist-row"
	*ngFor="let label of labels" (click)="updateAnswers(label, $event)">
	<div class="questionText pl-5 col-10 col-md-6">{{label.label}}</div>
	<div class="col-2 col-md-6">
		<input id="check-{{label.id}}" type="checkbox" class="form-control col-2" 
		[checked]="isAnswer(label)" (click)="updateAnswers(label, $event)" />
		<label for="check-{{label.id}}"></label>
	</div>
</div>



// WEBPACK FOOTER //
// ./src/app/assessments/question-checklist/question-checklist.component.html